/* eslint-disable no-console */
import actionTypes from 'constants/actionTypes';
import Api from '../services/api';
import apiURLBuilder from '../core/apiURLBuilder';
import { callcenterKO } from 'actions/identityValidationActions';
import { goToErrorsView } from './errorViewNavigation';

const getCreditCardPDFContract = async (dispatch, accessToken) => {
    const headerParams = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    try {
        const response = await Api.get(apiURLBuilder.getURL('pdfINE'), headerParams, 'json', '*/*');
        if (response && response.status && response.status === 200) {
            dispatch({
                type: actionTypes.GET_INE_PDF,
                data: response.text,
            });

            return response.text;
        }
    } catch (error) {
        return error;
    }
};

const getCreditCardPDF = accessToken => {
    return async dispatch => {
        return await getCreditCardPDFContract(dispatch, accessToken);
    };
};

const insertIbanForCreditCard = async (dispatch, accessToken, requestObject) => {
    try {
        const requestParams = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: requestObject,
        };

        const { body } = await Api.post(apiURLBuilder.getURL('ibanCreditCardCreation'), requestParams);

        return body.status;
    } catch (error) {
        return error;
    }
};

const insertIbanCreditCard = (accessToken, requestObject) => {
    return async dispatch => {
        const response = await insertIbanForCreditCard(dispatch, accessToken, requestObject);

        return response && response.status && response.status === 200 ? {} : response;
    };
};

const getCreditCardLimitRequest = async (dispatch, accessToken) => {
    const getCreditCardLimitURL = apiURLBuilder.getURL('creditCardLimit');
    try {
        const requestParams = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
        };
        const {
            body: { limit },
        } = await Api.get(getCreditCardLimitURL, requestParams);

        if (limit === 0 || limit === '0') throw new Error('asnef');

        return limit;
    } catch (error) {
        if (error.message === 'asnef') return callcenterKO(dispatch);
        dispatch(goToErrorsView({ errorMessage: getCreditCardLimitURL }));
    }
};

const getCreditCardLimit = accessToken => {
    return async dispatch => {
        const response = await getCreditCardLimitRequest(dispatch, accessToken);

        return response ? response : dispatch(goToErrorsView());
    };
};

const verifyCirbeRequest = async accessToken => {
    const requestParams = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { body } = await Api.post(apiURLBuilder.getURL('cirbeVerify'), requestParams);

    return body.status;
};

const executeCirbeRequest = accessToken => {
    return async () => await verifyCirbeRequest(accessToken);
};

export default { insertIbanCreditCard, getCreditCardPDF, getCreditCardLimit, executeCirbeRequest };
